<template>
  <div class="-trend">
    <div class="c_main -pad-btm">
      <div class="inner">
        <nav class="c_pnkz">
          <ul class="c_pnkz_list">
            <li>
              <a class="c_pointer" @click="$router.push({ name: 'Home' })">
                ホーム
              </a>
            </li>
            <li>{{ contents.title }}</li>
          </ul>
        </nav>

        <video-single ref="video" :contents="contents"></video-single>

        <div class="c_pageback">
          <a class="c_txtlink" @click="$router.push({ name: 'Home' })">
            トップに戻る
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoSingle from "@/components/VideoSingle";

export default {
  components: {
    VideoSingle
  },
  props: {
    id: {
      type: String
    },
    category: {
      type: String
    },
    routerName: {
      type: String
    }
  },
  data() {
    return {
      contents: {}
    };
  },
  created() {
    this.fetchContents();
  },
  methods: {
    fetchContents() {
      this.loadingContents = true;

      this.$authAxios
        .get(`/api/contents/${this.id}/`)
        .then(response => {
          this.contents = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingContents = false;
          this.$refs.video.init();
        });
    }
  }
};
</script>
